'use strict';

var JQXGridCellTreatmentUserManagementService = function JQXGridCellTreatmentUserManagementService() {
  var HIDDEN_OPTION_CLASS = 'rm-jqx-grid-cell-hidden';
  var onlyReadComponents = ['dashboard', 'rom', 'data-extract', 'history', 'pricing-summary', 'pricing-analysis'];
  var onlyWriteComponents = ['user-management'];
  function onlyReadComponentClasses(datafield, rowData, classNames) {
    if (datafield === 'isEditable' && rowData && rowData.component && onlyReadComponents.indexOf(rowData.component) > -1) {
      classNames.push(HIDDEN_OPTION_CLASS);
    }
    if (datafield === 'isViewable' && rowData && rowData.component && onlyWriteComponents.indexOf(rowData.component) > -1) {
      classNames.push(HIDDEN_OPTION_CLASS);
    }
  }
  function getClasses(rowId, rowData, selectedrowindexes, datafield) {
    var classNames = [];
    onlyReadComponentClasses(datafield, rowData, classNames);
    return classNames;
  }
  return {
    getClasses: getClasses
  };
};
JQXGridCellTreatmentUserManagementService.$inject = [];
module.exports = JQXGridCellTreatmentUserManagementService;